import { CONTENT_MARKETING_CLASS_NAME } from '@innhold/core/front/constants';
import { track } from '@innhold/core/tracking/partnerstudio';
import { createViewObserverWithTimeout } from '@innhold/core/tracking/utils/createViewObserver';

export default async () => {
    createViewObserverWithTimeout(`.${CONTENT_MARKETING_CLASS_NAME}`, track);
};
